import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatDateForDisplay } from '../utils/dateFormat';

export default function RenewalDraftInvoices({ onClose }) {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const [page, setPage] = useState(0);
  const pageSize = 10;
  const totalPages = Math.ceil((items?.length || 0) / pageSize);
  const headerStyle = { padding: '12px', textAlign: 'left', borderBottom: '2px solid var(--light-blue)' };
  const cellStyle = { padding: '12px' };
  useEffect(() => {
    let active = true;
    axios.get('/api/renewal-drafts').then(({ data }) => { if (active) setItems(data); })
      .catch(e => { if (active) setError(e.response?.data?.message || 'Unable to load draft invoices.'); });
    return () => { active = false; };
  }, []);
  return <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
    <div role="dialog" aria-modal="true" aria-labelledby="draftInvoicesTitle" style={{ background: 'var(--white)', borderRadius: '12px', padding: '30px', width: '95%', maxWidth: '1000px', maxHeight: '90vh', overflowY: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 id="draftInvoicesTitle" style={{ color: 'var(--dark-blue)', margin: 0 }}>Draft Invoices ({items?.length ?? '…'})</h3>
        <button type="button" onClick={onClose} aria-label="Close draft invoices" style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: 'var(--gray-dark)' }}>×</button>
      </div>
      {error ? <div role="alert" className="alert alert-error">{error}</div> : items === null ? <div className="loading">Loading data...</div> : items.length ? <>
        <div style={{ marginBottom: '15px', fontSize: '14px', color: 'var(--gray-dark)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, items.length)} of {items.length} invoices</span>
          <span>Page {page + 1} of {totalPages}</span>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead><tr style={{ backgroundColor: 'var(--pale-blue)' }}>
              <th scope="col" style={headerStyle}>Customer</th>
              <th scope="col" style={headerStyle}>Program</th>
              <th scope="col" style={headerStyle}>Program Dates</th>
              <th scope="col" style={headerStyle}>Invoice Date</th>
              <th scope="col" style={{ ...headerStyle, textAlign: 'right' }}>Amount</th>
              <th scope="col" style={{ ...headerStyle, textAlign: 'center' }}>Actions</th>
            </tr></thead>
            <tbody>{items.slice(page * pageSize, (page + 1) * pageSize).map((d, index) => <tr key={d.id} style={{ backgroundColor: index % 2 === 0 ? 'var(--white)' : 'var(--gray-light)', borderBottom: '1px solid var(--gray-medium)' }}>
              <td style={{ ...cellStyle, fontWeight: '500' }}>{d.customerName}</td>
              <td style={cellStyle}>{d.programName}</td>
              <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>
                <div>{formatDateForDisplay(d.startDate) || '-'}</div>
                <div style={{ fontSize: '12px', color: 'var(--gray-dark)', marginTop: '3px' }}>to {formatDateForDisplay(d.endDate) || '-'}</div>
              </td>
              <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>{formatDateForDisplay(d.invoiceDate) || '-'}</td>
              <td style={{ ...cellStyle, textAlign: 'right', fontWeight: '600', whiteSpace: 'nowrap' }}>₹{Number(d.total ?? 0).toFixed(2)}</td>
              <td style={{ ...cellStyle, textAlign: 'center' }}>
                <button type="button" className="btn btn-primary" style={{ fontSize: '11px', padding: '4px 8px', whiteSpace: 'nowrap' }} onClick={() => { onClose(); navigate(`/customers/${d.customerId}?tab=invoices&renewalDraft=${d.id}`); }}>Create invoice</button>
              </td>
            </tr>)}</tbody>
          </table>
        </div>
        {totalPages > 1 && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', gap: '10px' }}>
          <button type="button" className="btn btn-secondary" disabled={page === 0} onClick={() => setPage(page - 1)} style={{ fontSize: '12px', padding: '6px 12px' }}>Previous</button>
          <span style={{ fontSize: '14px', color: 'var(--gray-dark)' }}>Page {page + 1} of {totalPages}</span>
          <button type="button" className="btn btn-secondary" disabled={page === totalPages - 1} onClick={() => setPage(page + 1)} style={{ fontSize: '12px', padding: '6px 12px' }}>Next</button>
        </div>}
      </> : <div style={{ textAlign: 'center', padding: '40px', color: 'var(--gray-dark)' }}>No draft invoices found.</div>}
    </div>
  </div>;
}
